module.exports = __webpack_public_path__ + "81a1bc6512080681fd2a9860985f669d.jpg";